import { Environment } from "@skylab-shared/types";

export const environment: Environment = {
  testdev: true,
  clarityId: 'z7cvcj7kjp'
};
